var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Timesheet","items":_vm.items,"doc":_vm.doc},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":_vm.create}})]},proxy:true}])},[_c('Hints'),_c('Form',{ref:"form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }